import { Certificate, isCertificate } from '../entities/certificate';
import { http } from '../http';

export async function getUserCertificates() {
	const userCertificates = await http.get<Certificate[]>('/certificates');
	if (
		(userCertificates ?? []).every((userCertificate) =>
			isCertificate(userCertificate),
		)
	) {
		return userCertificates;
	} else {
		throw TypeError();
	}
}
